import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Film } from 'lucide-react';
import PosterGrid from '@components/streamflow/PosterGrid';
import type { Channel } from '@lib/streamFlowApi';

/**
 * /movies — VOD browse surface.
 *
 * Mirrors the dashboard's channel-grid pattern but for kind='vod'. Click
 * on a poster navigates to /watch/:id, which the existing StreamPlayer
 * handles transparently — the /api/stream/url handler resolves the
 * channel's sources and the URL builder picks /movie/<u>/<p>/<id> based
 * on the source's stream_type.
 *
 * Episode-level browsing for series lives in /series — keeping the two
 * surfaces separate avoids mixing single-shot movies with the
 * series → seasons → episodes hierarchy.
 */
export default function Movies() {
  const navigate = useNavigate();

  const onPlay = (channel: Channel) => {
    navigate(`/watch/${channel.id}`);
  };

  return (
    <div className="max-w-6xl mx-auto px-4 py-6">
      <button
        onClick={() => navigate('/')}
        className="flex items-center gap-2 text-sm text-gray-600 hover:text-gray-900 mb-4"
      >
        <ArrowLeft className="w-4 h-4" />
        Back to Dashboard
      </button>

      <div className="flex items-center gap-2 mb-4">
        <Film className="w-6 h-6 text-slate-800" />
        <h1 className="text-2xl font-bold">Movies</h1>
      </div>

      <PosterGrid kind="vod" onPlay={onPlay} />
    </div>
  );
}
